import axios from 'axios';

const updateExportSections = ({ id, section_ids }) => {
  return axios.put(`imports/${id}/settings`, { section_ids });
};

export { updateExportSections };
